import React from 'react'
import { NoticeBox } from '@core/Components/NoticeBox'
import { ContactDetailsLink } from './ContactDetailsLink'

export const NoEmailAddress: React.FC<{ accountNumber?: number }> = ({ accountNumber }) => (
  <NoticeBox
    role='alert'
    testId='no-email-addresses'
    noticeBoxType='Error'
    title='No email addresses'
    hasBorder
  >
    <p>
      There are no email addresses on your account,{' '}
      <ContactDetailsLink accountNumber={accountNumber}>click here to add one</ContactDetailsLink>
    </p>
  </NoticeBox>
)
